module.exports = __webpack_public_path__ + "img/0527-m.e05b6bf9.svg";